import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Post } from '../models/post.model';
import { GetPostRequest } from '../models/request.model';

@Injectable({
  providedIn: 'root'
})
export class PostsService {
  private readonly apiUrl = `${environment.apiUrl}/posts`;

  constructor(private http: HttpClient) { }

  getPosts(request: GetPostRequest): Observable<Post[]> {
    return this.http.get<Post[]>(`${this.apiUrl}?pageType=${request.pageType}&period=${request.period}&order=${request.order}&limit=${request.limit}&lang=${request.lang}`);
  }

  getPostById(id: number, lang: string = 'en'): Observable<Post> {
    return this.http.get<Post>(`${this.apiUrl}/${id}?lang=${lang}`);
  }
}
